import { ICloneable } from '../../contracts/cloneable.js';
import { IDataComparable } from '../../contracts/data-comparable.js';
import { kAppointmentTimeIncrement } from '../../utility/constants.js';
import { CalendarEntry } from '../calendar-entry.js';
import { cloneList, cloneMap, isSameList, isSameMap } from '../dto/dto.js';
import { TimeOfDay } from './time-of-day.js';

export class StaffCalendarSnapshot implements ICloneable, IDataComparable {
  constructor(
    public readonly staffId: string,
    public readonly calendarState: Map<number, string[]>,
  ) {}

  static empty(staffId: string): StaffCalendarSnapshot {
    return new StaffCalendarSnapshot(
        staffId,
        new Map<number, string[]>(),
    );
  }

  isFreeAtTimeOfDay(timeOfDay: TimeOfDay): boolean {
    return this.isFreeAtMinute(timeOfDay.inMinutes);
  }

  isFreeAtMinute(minute: number): boolean {
    const key = Math.floor(minute / kAppointmentTimeIncrement);
    const list = this.calendarState.get(key);

    return list ? list.length === 0 : true;
  }

  addAppointmentAtTimeOfDay(timeOfDay: TimeOfDay, appointment: CalendarEntry): void {
    this.addAppointmentAtMinute(timeOfDay.minute, appointment);
  }

  addAppointmentAtMinute(minute: number, appointment: CalendarEntry): void {
    const key = Math.floor(minute / kAppointmentTimeIncrement);
    let list: string[] | undefined = this.calendarState.get(key);
    if(!list) {
      list = [];
      this.calendarState.set(key, list);
    }

    list.push(appointment.uniqueId);
  }

  clone(): this {
    return new StaffCalendarSnapshot(
        this.staffId,
        cloneMap(this.calendarState, (v) => cloneList<string>(v)),
    ) as this;
  }

  isSame(other: StaffCalendarSnapshot): boolean {
    if(this === other) {
      return true;
    }

    return isSameMap(other.calendarState, this.calendarState, isSameList);
  }

  toDiagnosticsObject(): Record<string, unknown> {
    const calendarState: Record<string, unknown> = {};
    for(const [k, v] of this.calendarState) {
      calendarState[k.toString()] = v;
    }

    return calendarState;
  }
}
